import { createFileRoute } from '@tanstack/react-router';

import { LoginByTokenPageWidget } from '@features/auth/pages/LoginByTokenPage';

export const Route = createFileRoute('/auth/by-token')({
  component: Page,
  validateSearch: (search) => {
    return {
      token: search?.token,
      back: search?.back,
    } as { token?: string; back?: string };
  },
});

function Page() {
  const search = Route.useSearch();
  return <LoginByTokenPageWidget token={search.token} back={search.back} />;
}
